module.exports = __webpack_public_path__ + "img/uid-guide-img-1.688407bf.jpeg";